<script>
import MenuUser from './menu/user/user'
import MenuConfig from './menu/config/config'
import MenuConfigProfessional from './menu/config/config-professional'
import Notifications from './notifications'
import { mapGetters } from 'vuex'

export default {
  name: 'toolbar',
  components: {
    MenuUser,
    MenuConfig,
    Notifications,
    MenuConfigProfessional
  },
  computed: {
    ...mapGetters(['user', 'userIsProfessional', 'userIsCompany'])
  }
}
</script>

<template lang="pug">
  ul.right-menu
    //- notifications
    li
    menu-config-professional(v-if="userIsProfessional || userIsCompany")
    menu-config(v-if="user.type === 'patient'")
    menu-user
</template>



// WEBPACK FOOTER //
// src/layout/headers/toolbar.vue